import axios from "axios";

export default axios.create({
    baseURL: "https://app.ecoraapp.com:8094/api",//"https://app.ecoraapp.com:8094/api",//"http://localhost:8080/api", //https://app.ecoraapp.com:8094
    headers: {
        "Content-type": "application/json"
    }
});